import Vue from 'vue'
import { isOpaqueError, withErrorRef } from '@/apiErrorRef'
import Config from '@/config'

const initialState = () => ({
  mode: null,
  features: [],
  products: [],
  attachments: [],
  includeArchived: false,
  isLoading: false,
  loaded: false,
  loadError: '',
})

export const catalogState = Vue.observable(initialState())

let reloadQueued = false

export const resetCatalog = () => {
  Object.assign(catalogState, initialState())
  reloadQueued = false
}

const failureMessage = error =>
  (error && error.body && (error.body.error || error.body.message)) ||
  (!isOpaqueError(error) && error && error.bodyText) ||
  withErrorRef(error, 'Could not load the Stripe catalogue. Please try again.')

export const loadCatalog = async () => {
  if (catalogState.isLoading) {
    reloadQueued = true
    return
  }
  reloadQueued = false
  catalogState.isLoading = true
  catalogState.loadError = ''
  try {
    const res = await Vue.http.get(Config.api.stripeMirrorCatalog, {
      params: { includeArchived: catalogState.includeArchived },
    })
    catalogState.mode = res.body.mode
    catalogState.features = res.body.features || []
    catalogState.products = res.body.products || []
    catalogState.attachments = res.body.attachments || []
    catalogState.loaded = true
  } catch (error) {
    catalogState.loadError = failureMessage(error)
  } finally {
    catalogState.isLoading = false
    if (reloadQueued) loadCatalog()
  }
}
